module.exports = __webpack_public_path__ + "img/biolink-fullcolor.291268a.jpg";